// extracted by mini-css-extract-plugin
export default {"main":"box_main__CDlcu","detail":"box_detail__yJT7e"};